module.exports = __webpack_public_path__ + "img/xueshiArms.701ecf0e.png";